import { createSelector } from '@reduxjs/toolkit';
import { getImmutableCompatible } from 'src/utils/immutableUtils';

import { name } from './slice';
import type { PriceSubscriptionState } from './types';

export const priceSubscriptionSelector = (state): PriceSubscriptionState =>
  getImmutableCompatible(state, name);

export const isSubscribedOnPriceSelector = createSelector(
  priceSubscriptionSelector,
  (state) => state.isSubscribed,
);
